// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"tabs_tabsContainer__23QbK","tab":"tabs_tab__1g9Jc","selected":"tabs_selected__2GQ3r"};